export class AliasName {
	orderId: number;
	orderDate: Date;
	applicantId: number;
	referenceId: any;
	searchType: string;
	/** The Person_Alias.Id */
	id: number;
	fullName: string;
	applicantNotes : string;
	responseId:number;
	applicantReviewed : boolean;
	reviewedDate : Date;
	excludeFromReport : boolean;
	recordId : number;
	tableName : string;
	
	public get recordSource() : string {
		if(this.tableName.indexOf('Person') > -1) return 'SSN Trace'
		return 'Credit Search'
	}
	
}

export class CriminalRecord {
	orderId: number;
	orderDate: Date;
	applicantId: number;
	referenceId: any;
	searchType: string;
	recordId: number;
	offenseId: number;
	jurisdiction: string;
	offenseJurisdiction: string;
	caseNumber?: number;
	recordFileDate?: Date;
	recordProvider: string;
	providerState: string;
	offenderName: string;
	offenderStreet: string;
	city: string;
	state: string;
	zipCode: string;
	eyeColor: string;
	gender: string;
	hairColor: string;
	height: string;
	race: string;
	weight: string;
	offenseDescription: string;
	offenseType: string;
	dob: string;
	dispositionDate?: Date;
	dispositionData: string;
	probation: string;
	confinement: string;
	statuteNumber: string;
	arrestingAgency: string;
	plea: string;
	fine: string;
	offenseFileDate?: Date;
	offenseDate?: Date;
	applicantNotes: string;
	responseId: number;
	applicantReviewed: boolean;
	reviewedDate?: Date;
	offenses: CriminalRecordOffense[];
	excludeFromReport : boolean;
	duplicateJurisdictionToCheck: string;
	filteredBy : string;
	userName : string;
	criminalGridDecision : number;
	gridAlertNote : string;
	public get filteredByStr() : string {
		if(this.userName && this.filteredBy == 'ApplicantDataController') return this.userName;
		return this.filteredBy;
	}
	

	public get dateToShow() : Date {
		if(this.offenseFileDate) return this.offenseFileDate;
		else if(this.offenseDate) return this.offenseDate;
		else if(this.recordFileDate) return this.recordFileDate;
		else return this.dispositionDate;
	}
	
	index : number;
	filterDescription : string;
}
export class CriminalRecordOffense {
	offenseDescription: string;
	offenseType: string;
	dispositionDate?: Date;
	dispositionData: string;
	probation: string;
	confinement: string;
	statuteNumber: string;
	arrestingAgency: string;
	plea: string;
	fine: string;
	offenseFileDate?: Date;
	applicantNotes: string;
	responseId: number;
	applicantReviewed: boolean;
	sentenceData: string;
	reviewedDate?: Date;
	details : CriminalDetail[];

}

export class CriminalDetail{
	name:string;
	value : string;
	origin:string;
}

export class EvictionRecord {
	orderId: number;
	orderDate: Date;
	applicantId: number;
	referenceId: any;
	searchType: string;
	responseDataId: number;
	offenderName: string;
	evictionRecordId: number;
	caseNumber: string;
	caseType: string;
	caseDisposition: string;
	caseComments: string;
	courtLocation: string;
	applicantNotes: string;
	plantiff: string;
	claimAmount: string;
	evictionReferenceId: string;
	judgementAmount: string;
	fileDate: string;
	addressLine: string;
	city: string;
	state: string;
	zipCode: string;
	responseId: number;
	applicantReviewed: boolean;
	reviewedDate?: Date;
	excludeFromReport : boolean;
	filteredBy : string;
	userName : string;
	
	public get filteredByStr() : string {
		if(this.userName && this.filteredBy == 'ApplicantDataController') return this.userName;
		return this.filteredBy;
	}
	
	index : number;
	filterDescription : string;
}

export class PreviousAddress {
	applicantNotes : string;
	orderId: number;
	orderDate: Date;
	applicantId: number;
	referenceId: any;
	searchType: string;
	/** Person_Address.Id */
	tableName : string;
	id: number;
	countryCode: string;
	postalCode: string;
	region: string;
	city: string;
	county: string;
	street: string;
	dateFirstReported: string;
	dateLastReported: string;
	responseId:number;
	applicantReviewed : boolean;
	reviewedDate : Date;
	excludeFromReport : boolean;
	recordId : number;

	public get recordSource() : string {
		if(this.tableName.indexOf('Person') > -1) return 'SSN Trace'
		return 'Credit Search'
	}
	get firstReported() : string {
		if(this.dateFirstReported != null && this.dateFirstReported.indexOf('/') < 0){
			// then its in the taz YYYYMMDD format
			let yr = this.dateFirstReported.substring(0,4);
			let mo = this.dateFirstReported.substring(4,6);
			let dy = this.dateFirstReported.substring(6,8);
			return `${yr}-${mo}-${dy}`;
		}else
		return this.dateFirstReported;
	}
	get lastReported() : string {

		if(this.dateLastReported != null && this.dateLastReported.indexOf('/') < 0) {

		  if (this.dateLastReported.indexOf('-') < 0) {
        // then its in the taz YYYYMMDD format
        let yr = this.dateLastReported.substring(0, 4);
        let mo = this.dateLastReported.substring(4, 6);
        let dy = this.dateLastReported.substring(6, 8);

        return `${yr}-${mo}-${dy}`;
      }
		}
		return this.dateLastReported;
	}
}


export class EmployerVerificationData
{
	id: number;
	organizationName: string;
	employerCity: string;
	employerState: string;
	title: string;
	startDate: string;
	endDate: string;
	screeningId: number;
	screeningDraftId : number;
	contactName : string;
	employerPhone : string;
	employerEmail : string;
	public get isComplete() : boolean {
		return (this.organizationName != undefined 
			&& this.employerCity != undefined 
			&& this.employerState != undefined
			&& this.title != undefined 
			&& this.startDate  != undefined
			&& this.contactName != undefined)
	}
	
}

export class ReferenceVerificationData
{
	id: number;
	startDate: string;
	endDate: Date;
	screeningId: number;
	screeningDraftId: number;
	postalCode: string;
	state: string;
	city: string;
	street: string;
	contactName: string;
	contactTelephone: string;
	contactEmail: string;
	formattedStartDate : string;

	
	public get startDateString() : string {
		if(this.startDate)
			return this.startDate.split('T')[0];
		else return this.startDate;
	}

	
	public set startDateString(v : string) {
		this.startDate = v;
	}
	
	
}

export class VerificationCallPattern {
	id: number;
	key: string;
	prettyValue: string;
}

export class ApplicantTaxLien {
	orderId: number;
	orderDate: Date;
	applicantId: number;
	referenceId: any;
	searchType: string;
	responseId: number;
	fullName: string;
	ssn: string;
	street: string;
	city: string;
	state: string;
	zipCode: string;
	filingId: number;
	plaintiff: string;
	caseNumber:string;
	filingGroupDesc: string;
	filingTypeDesc: string;
	courtDesc: string;
	filingState: string;
	filingDate: string;

	get filingDateP() : string {
		if(this.filingDate != null && this.filingDate.indexOf('-') < 0){
			// then its in the taz YYYYMMDD format
			let yr = this.filingDate.substring(0,4);
			let mo = this.filingDate.substring(4,6);
			let dy = this.filingDate.substring(6,8);
			return `${yr}-${mo}-${dy}`;
		}else
		return this.filingDate;
	}

	judgmentDate: string;
	assetAmount: number;
	liabilityAmount: number;
	judgmentAmount: number;
	initialDate: string;
	applicantReviewed: boolean;
	reviewedDate?: Date;
	applicantNotes: string;
	excludeFromReport : boolean;
	recordId : number;
}

export class SSNTrace {
	orderId: number;
	orderDate: Date;
	applicantId: number;
	referenceId: any;
	firstName: string;
	lastName: string;
	ssn: string;
	dOB?: Date;
	ssnState: string;
	ssnYear: string;
	deceased?: boolean;
	includeWithReport : boolean = true;
}

export class ReferenceVerification {
	orderId : number;
	orderDate : Date;
	applicantId : number;
	referenceId : any;
	searchType : string;
	id : number;
	contactName :string;
	phone :string;
	email :string;
	address1 :string;
	address2 :string;
	city :string;
	state :string;
	country :string;
	postalCode :string;
	referenceType :string;
	relationship :string;
	forceCloseDate :Date;
	alternateOutcome :string;
	agentName :string;
	resultsDetails :string;
	verifiedDate :Date;
	verifiedById :string;
	verifiedBySource :string;
	verifiedByName :string;
	verifiedByTitle :string;
	verifiedByCallNumber :string;
	excludeFromReport : boolean;
	resultResponse : string;
	questions : ReferenceVerificationQuestion[];
	callAttempts: VerificationCall[]
	notes : string;
	responseId: number;
}

export class EmploymentVerification {
	orderId : number;
	orderDate : Date;
	applicantId : number;
	referenceId : any;
	searchType : string;
	id : number;
	employer : string;
	employerVerified : boolean;
	employerDiscovered : string;
	address1 : string;
	address1Verified : boolean;
	address1Discovered : string;
	address2 : string;
	city : string;
	cityVerified : boolean;
	cityDiscovered : string;
	country : string;
	countryVerified : boolean;
	countryDiscovered : string;
	title : string;
	titleVerified : boolean;
	titleDiscovered : string;
	reasonForLeaving : string;
	reasonForLeavingVerified : boolean;
	reasonForLeavingDiscovered : string;
	compensation : string;
	compensationVerified : boolean;
	compensationDiscovered : string;
	bonus : string;
	bonusVerified : boolean;
	bonusDiscovered : string;
	employedFrom : string;
	employedFromVerified : boolean;
	employedFromDiscovered : string;
	employedTo : string;
	employedToVerified : boolean;
	employedToDiscovered : string;
	phone : string;
	state : string;
	postalCode : string;
	contractor : string;
	supervisor : string;
	supervisorContactInfo : string;
	rehireEligibility : string;
	rehireEligibilityVerified : boolean;
	rehireEligibilityDiscovered : string;
	currentEmployment : string;
	currentEmploymentVerified : boolean;
	currentEmploymentDiscovered : string;
	contractType : string;
	contractTypeVerified : boolean;
	contractTypeDiscovered : string;
	forceCloseDate : Date;
	alternateOutcome : string;
	agentName : string;
	email : string;
	resultsDetails : string;
	comments : string;
	verifiedDate : Date;
	verifiedById : string;
	verifiedBySource : string;
	verifiedByName : string;
	verifiedByTitle : string;
	verifiedByCallNumber : string;
	excludeFromReport : boolean;
	resultResponse : string;
	notes: string;
	responseId : number;
}
export class VerificationQuestion {
	id : number;
	question : string;
	response : string;
	sort : number;
}

export class ReferenceVerificationQuestion extends VerificationQuestion {
  responseId: number;
	constructor(sort : number, question : string, response : string) {
		super();
		this.sort = sort;
		this.question = question;
		this.response = response;
	}
}

export class EmploymentVerificationQuestion extends VerificationQuestion {

}


export class VerificationCall
{
	Id: number;
	callDate: Date | string | null;
	nextCall: Date | string | null;
	callOutcome: string;
	callNumber: string;
	callBy: string;
	callsRemaining: number | null;
	callsAttempted: number | null;
	note: string;
	isCallAttempt: boolean | null;
	ResponseId: number;
}

export class VerificationCallPayload
{
	callAttempt : VerificationCall;
	callType : number; // should be 2 for residence or 3 for Employment

}